import Tabs from './Tabs.js';

export default Tabs;
